import {MultimediaDownloadInfo} from '@/types/matrix';
import axios from 'axios';
import {env} from '@/config';

export const downloadSingleMultimedia = (
  multimediaInfo: MultimediaDownloadInfo
) => {
  const {APP_VARIANT} = env;

  const variantLowerCase = APP_VARIANT.toLowerCase();

  const multimediaType = multimediaInfo.type;

  const mimeType = multimediaInfo.mimeType;

  const fileExtension = mimeType.split('/')[1];

  const fileName = `${variantLowerCase}_downloaded_${multimediaType}.${fileExtension}`;

  axios({
    url: multimediaInfo.url,
    method: 'GET',
    responseType: 'blob'
  })
    .then((response) => {
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => {
      console.error('Error in downloading file:', error);
    });
};
